import { GridFilterValue, SingleSelectFilterOperator } from './operators';
import { ScalarFilterValue } from './types';
import { neverReached } from 'shared/utils/neverReached';

export function matchesSingleSelectFilter(
  operator: SingleSelectFilterOperator,
  filterValue: ScalarFilterValue,
  cellValue: ScalarFilterValue
): boolean {
  // Empty filter value means that the filter is not applied (default behavior - first item is selected)
  if (operator === GridFilterValue.IS && filterValue === undefined) {
    return true;
  }

  switch (operator) {
    case GridFilterValue.IS:
      return cellValue === filterValue;
    default:
      return neverReached(operator);
  }
}
